import { atom } from 'jotai';

export const imageViewerOpenAtom = atom(false);
